import React from "react";
import { FaAndroid } from "react-icons/fa";
import { APK_URL, BRAND } from "../utils/config";
import { trackDownload } from "../utils/analytics";

// Gold call-to-action with a moving shine. `compact` is the small pill used in the header.
const DownloadButton = ({ compact = false, label, className = "" }) => (
  <a
    href={APK_URL}
    download
    rel="nofollow noopener"
    onClick={trackDownload}
    className={`rt-dl${compact ? " rt-dl--compact" : ""} ${className}`}
    aria-label={`Download ${BRAND.name} app (APK)`}
  >
    <span className="rt-dl__shine" aria-hidden="true" />
    <FaAndroid size={compact ? 16 : 26} aria-hidden="true" />
    {compact ? (
      <span>{label || "Download"}</span>
    ) : (
      <span className="rt-dl__txt">
        <small>Download App</small>
        <strong>{label || `Get ${BRAND.name} APK`}</strong>
      </span>
    )}
  </a>
);

export default DownloadButton;
